import { FC } from 'react';

import AccreditationApplication from './AccreditationApplication';
import { AccreditationTab } from './StepTypes';

type Props = {
  currentTab: AccreditationTab;
  onTabChange: (tab: AccreditationTab) => void;
  selectedInvestmentEntity: any | null;
  onProceedToSubmitStep: () => void;
  onBackStep: () => void;
  locked?: boolean;
};

const AccreditationApplicationTabs: FC<Props> = ({
  currentTab,
  onTabChange,
  selectedInvestmentEntity,
  onProceedToSubmitStep,
  onBackStep,
  locked,
}) => {
  return (
    <AccreditationApplication
      currentTab={currentTab}
      onTabChange={locked ? () => {} : onTabChange}
      selectedInvestmentEntity={selectedInvestmentEntity}
      onProceedToSubmitStep={onProceedToSubmitStep}
      onBackStep={onBackStep}
      locked={locked}
    />
  );
};

export default AccreditationApplicationTabs;
